import { useEffect, useState } from "react";
import { RefreshCw, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const when = (ts) => (ts ? new Date(ts).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "");

export const NewProductsNotice = ({ onSynced }) => {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = (refresh = false) => api.get(`/admin/shopify/new-products${refresh ? "?refresh=1" : ""}`).then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const sync = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post("/admin/shopify/sync-products");
      toast.success(`Shopify: ${r.total} prodotti · ${r.created} nuovi · ${r.updated} aggiornati`);
      await load(true);
      onSynced?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  if (!data || !data.count) return null;
  return (
    <div className="mb-6 border border-[#C5A059] bg-[#FBF3E3] p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="new-products-notice">
      <Sparkles size={18} className="text-[#8C6F3E] shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm text-[#1A1A18]" data-testid="new-products-count">
          <strong className="font-medium">{data.count} {data.count === 1 ? "prodotto pubblicato" : "prodotti pubblicati"} su Shopify</strong> {data.count === 1 ? "non è ancora" : "non sono ancora"} nel catalogo dell'advisor: finché non sincronizzi, non {data.count === 1 ? "può" : "possono"} comparire nelle routine.
        </p>
        <p className="text-xs text-[#8C6F3E] mt-1 truncate" data-testid="new-products-list">
          {data.items.slice(0, 4).map((p) => `${p.title}${p.published_at ? ` (${when(p.published_at)})` : ""}`).join(" · ")}{data.count > 4 ? ` · +${data.count - 4}` : ""}
        </p>
      </div>
      <button data-testid="new-products-sync-btn" className="fs-btn !py-2.5 !px-5 shrink-0" onClick={sync} disabled={busy}>
        <RefreshCw size={14} className={busy ? "animate-spin" : ""} /> Sincronizza ora
      </button>
    </div>
  );
};
